import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

export const VerticalDivider = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${Color.Black};
`
